import React, { useMemo } from 'react'
import { CURRENT_YEAR } from 'Config/League/league.config'
import { useAssistTracker } from 'Hooks/team'
import { useCountUp } from 'Hooks/animations/useCountUp'
import {
  TrackerContainer,
  ContentWrapper,
  SponsorsContainer,
  SponsorLogo,
  StatsContainer,
  StatBox,
  StatValue,
  StatLabel,
  Description,
  TrackerOuter,
} from './styles'
import { teamsBasicArray } from 'Constant/team'
import { PLL_IMAGES } from 'Config/config'

type TeamAssistTrackerProps = {
  teamId: string
}

export const TeamAssistTracker: React.FC<TeamAssistTrackerProps> = ({ teamId }) => {
  const { totalAssists, isLoading, error } = useAssistTracker({
    teamId,
    year: CURRENT_YEAR,
  })

  const team = useMemo(() => {
    const team = teamsBasicArray.find((team) => team.officialId === teamId)
    return team
  }, [teamId])

  const animatedAssists = useCountUp({ end: totalAssists, duration: 1500 })
  const animatedDonation = useCountUp({ end: totalAssists * 500, duration: 1500 })

  if (isLoading || error || !team) return null

  const titleId = 'assist-tracker-title'

  return (
    <TrackerOuter>
      <TrackerContainer aria-labelledby={titleId}>
        <ContentWrapper>
          <SponsorsContainer>
            <SponsorLogo
              src={PLL_IMAGES.assistTrackerBanner}
              alt="Assist Tracker Banner"
            />
          </SponsorsContainer>
          <StatsContainer>
            <StatBox>
              <StatValue role="status">{animatedAssists}</StatValue>
              <StatLabel>Assists</StatLabel>
            </StatBox>
            <StatBox>
              <StatValue role="status">${animatedDonation.toLocaleString()}</StatValue>
              <StatLabel>Donated</StatLabel>
            </StatBox>
          </StatsContainer>
        </ContentWrapper>
        <Description>
          Through the U.S. Bank x PLL Assists Campaign, U.S. Bank is donating $500 to
          Harlem Lacrosse Los Angeles for every California Redwoods assist - starting at
          Redwoods Homecoming weekend.
        </Description>
      </TrackerContainer>
    </TrackerOuter>
  )
}
